// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { file16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-file': IconFile;
    }
}

/**
 * The icon component for the 'file' icon
 */
export class IconFile extends Icon {
    public constructor() {
        super(file16X16);
    }
}

registerIcon('icon-file', IconFile);
export const iconFileTag = 'nimble-icon-file';
